// Local translations
export const T = {
  en_GB: {
    noForecastData: "No forecast data to display",
  },
  nb_NO: {
    noForecastData: "Ingen prognosedata aa vise",
  },
} as const;
